const HTML_ENTITIES: Record<string, string> = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&nbsp;': ' ',
}

export default function getHTMLText(html: string | null | undefined): string | null {
  if (!html) return null

  return html.replaceAll(/<[^>]+>/g, '').replaceAll(/&[#\w]+;/g, match => HTML_ENTITIES[match] || match)
}
